import React from "react";
import { Dog, Handshake, MapPin } from "lucide-react";

const items = [
  {
    icon: Dog,
    text: "Especialistas en pequeños animales",
    testid: "trust-specialists",
  },
  {
    icon: Handshake,
    text: "Trato 100% personalizado",
    testid: "trust-personal",
  },
  {
    icon: MapPin,
    text: "Leganés (C. Melilla, 5)",
    testid: "trust-location",
  },
];

export const TrustBar = () => {
  return (
    <section
      data-testid="trust-bar"
      className="relative bg-gradient-to-br from-violet-50 via-cyan-50 to-violet-50 border-y border-violet-100/60"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <div
                key={item.testid}
                data-testid={item.testid}
                className="flex items-center gap-4 justify-center md:justify-start"
              >
                <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-white shadow-sm flex items-center justify-center text-violet-600 ring-1 ring-violet-100">
                  <Icon className="w-6 h-6" strokeWidth={2.2} />
                </div>
                <p className="text-slate-700 font-medium text-base md:text-lg">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
